import { render, staticRenderFns } from "./saveAMAllocation.vue?vue&type=template&id=27213d99"
import script from "./saveAMAllocation.vue?vue&type=script&lang=js"
export * from "./saveAMAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports